(function () {
	'use strict';

	angular.module('widgets.supplychain')
	.config(lateDeliveryCausesConfig);

	function lateDeliveryCausesConfig(dashboardProvider) {
		// register widget
		dashboardProvider
			.widget('lateDeliveryCauses',
				{
					name: 'Late Delivery Causes',
					description: 'Shows POs late delivery causes',
					thumbnailUrl: '/application/library/javascript/angular_dashboard/js/src/images/POs-to-Action-Next-12-Months.png',
					categories: [],
					config: {},
					slideshowView: true,
					isActive: true,
					controller: 'lateDeliveryCausesChart',
					templateUrl: '/application/f/dashboard/widgets/late-delivery-causes-chart.html',
					reload: true,
					isDrillDown: false,
					nonRemovable: true
				}
			);
	}
})();
